import DocumentCategoryList from "../components/document-category/DocumentCategoryCrud";

const DocumentCategoryCrudPage = () => {
  return (
    <>
      <DocumentCategoryList />
    </>
  );
};

export default DocumentCategoryCrudPage;
